// extracted by mini-css-extract-plugin
module.exports = {"toggle":"_1eDVG","menu":"_1O1VB"};